export default __webpack_public_path__ + "static/media/painting18.948a661a.jpg";